<template>
  <div>
    <div class="modal" :class="{ 'shift-right': isCreateCustomDB }">
      <div class="content">
        <div class="pull-right">
          <div class="btn-close" @click="close"></div>
        </div>
        <div class="tab">
          <h1>Element Bearbeiten</h1>
          <form id="add-element" @submit.prevent="handleSubmission">
            <label for="name">Name</label>
            <input
              name="name"
              type="text"
              :disabled="
                ['togglelist', 'wrapper'].includes(element.type) ||
                !isUserHasAccess ||
                isSheetDatabaseType
              "
              v-model="element.name"
              required
              onkeyup="this.value = this.value.toLowerCase()"
              @blur="transformName"
              pattern="^[a-z0-9äöü]+$"
              :class="{
                'already-exists': nameAlreadyExists && element.name != '',
                error: shakeName && nameAlreadyExists,
              }"
            />
            <label for="label">Bezeichnung</label>
            <input name="label" type="text" v-model="element.label" />

            <div v-if="element.type === 'linktodb'" class="link-db-container">
              <label for="label">Datenbank</label>
              <GeneralDropdown className="database-dropdown" class="mb-3">
                <template v-slot:selectFilter>
                  {{
                    element.selectedDatabaseCaption
                      ? element.selectedDatabaseCaption
                      : 'select'
                  }}
                </template>
                <template v-slot:optionData>
                  <b-dropdown-item
                    v-for="(item, index) in getDatabaseList"
                    :key="`${item.name}-${index}`"
                    @click="selectDatabaseLink(item, true)"
                  >
                    {{ item.caption }}
                  </b-dropdown-item>
                </template>
              </GeneralDropdown>
            </div>

            <div v-if="element.type === 'linktodb'" class="link-db-container">
              <label for="label">Item Id</label>
              <GeneralDropdown className="database-dropdown" class="mb-3">
                <template v-slot:selectFilter>
                  <span class="database-dropdown-value-container">
                    {{ element.value ? element.value : 'select' }}
                  </span>
                </template>
                <template v-slot:optionData>
                  <b-dropdown-item
                    style="height: 40px"
                    v-if="isDbItemListLoading"
                  >
                    <div class="loading-overlay">
                      <div class="progress-icon"></div>
                    </div>
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-for="(item, index) in databaseItemsList"
                    :key="`${item.id}-${index}`"
                    @click="onDatabaseItemChange(item)"
                    v-show="!isDbItemListLoading"
                  >
                    {{ item.id }}
                  </b-dropdown-item>
                </template>
              </GeneralDropdown>
            </div>

            <div v-show="elementNeedsOptions">
              <label>Optionen:</label>
              <div
                v-for="(option, index) in element.options"
                :key="index"
                class="options"
                :class="{ large: isCardItem || element.type === 'select' }"
              >
                <table>
                  <tr>
                    <td>
                      <input
                        v-if="element.type === 'radio'"
                        :type="element.type"
                        :id="element.name + option.label"
                        :name="element.name"
                        :value="option.label"
                        @change="changeChecked(option, element.type)"
                        :checked="option.checked"
                        :disabled="!isUserHasAccess"
                      />
                      <input
                        v-if="element.type === 'checkbox'"
                        :type="element.type"
                        :id="element.name + option.label"
                        :name="element.name"
                        :value="option.label"
                        :checked="option.checked"
                        @change="changeChecked(option, element.type)"
                        :disabled="
                          element.attributes.disabled || !isUserHasAccess
                        "
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        placeholder="Option"
                        v-model="option.label"
                        :disabled="!isUserHasAccess"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td class="img-preview">
                      <img v-if="isCardItem && option.img" :src="option.img" />
                    </td>
                    <td>
                      <div v-if="isCardItem" class="icon-picker-url-selector">
                        <div
                          class="btn"
                          @click.stop="toggleIconPickerURL(index)"
                        >
                          <span> Bild hinzufügen </span>
                        </div>

                        <IconPicker
                          v-if="index == iconPickerURLId"
                          :displayIconPickerSections="[
                            'icon',
                            'illustration',
                            'custom',
                          ]"
                          :element="option"
                          @updateUrl="
                            (icon) => {
                              updateUrl(icon, index);
                            }
                          "
                          @updateLinkType="
                            (tab) => {
                              updateLinkType(tab, index);
                            }
                          "
                          v-click-outside="toggleIconPickerURL"
                        />
                      </div>

                      <input
                        v-if="element.type === 'select'"
                        type="text"
                        placeholder="Option"
                        v-model="option.value"
                        :disabled="!isUserHasAccess"
                      />
                    </td>
                  </tr>
                  <tr v-if="isChoiceWithAppearanceCard(element)">
                    <td></td>
                    <td>
                      <textarea
                        v-if="isShowDescription"
                        class="description-input"
                        :id="`description-${index}-0`"
                        placeholder="Description"
                        v-model="option.description"
                        :disabled="!isUserHasAccess"
                      />
                    </td>
                  </tr>
                </table>

                <i class="far fa-trash-alt" @click="removeElement(option)"></i>
              </div>
              <div>
                <div class="element-image" v-if="element.type === 'video'">
                  <input
                    type="text"
                    placeholder="Video URL"
                    v-model="element.url"
                    required
                    :disabled="!isUserHasAccess"
                  />
                </div>
                <div
                  class="element-image icon-picker-url-selector"
                  v-if="element.type === 'image'"
                >
                  <div
                    class="btn"
                    @click.stop="toggleIconPickerURL(element.id)"
                  >
                    <span> Bild hinzufügen </span>
                  </div>

                  <IconPicker
                    v-if="element.id == iconPickerURLId"
                    v-click-outside="toggleIconPickerURL"
                    :displayIconPickerSections="[
                      'icon',
                      'illustration',
                      'custom',
                    ]"
                    :element="element"
                    @updateUrl="updateUrl"
                    @updateLinkType="updateLinkType"
                  />
                </div>
              </div>
              <input
                v-if="addAnotherOption"
                :class="{ invalid: this.invalidOptionName }"
                class="new-item"
                ref="newOption"
                type="text"
                placeholder="Neue Option Hinzufügen ..."
                @change="addOption(element)"
                :disabled="!isUserHasAccess"
              />
              <p v-if="this.invalidOptionName" class="invalid">
                Option existiert schon
              </p>
            </div>

            <!-- List items -->
            <div v-if="element.type === 'objectlist'" class="list-wrapper">
              <label>Schema</label>
              <div class="schema-item">
                <span v-if="element.schema.length === 0"
                  >Konfigurieren Sie Ihren Listeneintrag.</span
                >
                <FormBuilder
                  class="el-props-form-builder"
                  :elements="element.schema"
                  :structure="baseStructure"
                  :isFullWidth="false"
                  :isEditable="true"
                  :isContentEditable="true"
                  :elsToShow="[
                    'text',
                    'number',
                    'checkbox',
                    'radio',
                    'date',
                    'datetime-local',
                    'email',
                    'formated number',
                  ]"
                  @saveElements="saveListSchema"
                />
              </div>
              <div class="item-list" v-if="element.schema.length != 0">
                <label>Items</label>
                <Cards
                  :schema="element.schema"
                  :cards="element.value"
                  :itemWidth="'80%'"
                />
              </div>
            </div>
            <!-- List items end -->

            <label v-show="getLabelCaption(element.type)">{{
              getLabelCaption(element.type)
            }}</label>
            <!-- File Picker  Start -->
            <div class="edit-item">
              <FilePicker
                v-if="element.type === 'filenew'"
                ref="filePickerRef"
                @onFileSelected="onFileSelected"
                @onFileDelete="onFileDelete"
                :value="element.value"
              />
            </div>
            <!-- File Picker End -->

            <!-- Sheet  Start -->
            <div v-if="element.type === 'sheet'">
              <div class="btn" @click="$refs.hiddenSheetInput.click()">
                <span>Create Schema</span>
              </div>
              <input
                @change="onSheetFileSelect"
                ref="hiddenSheetInput"
                type="file"
                accept=".xls, .xlsx, .csv"
                hidden
              />
            </div>
            <!-- Sheet  End -->
            <input
              v-if="element.type === 'file'"
              name="example"
              :type="element.type"
              @change="getFiles"
              required
              :disabled="!isUserHasAccess"
            />
            <span v-if="element.type === 'range'" style="font-size: 15px">{{
              element.value
            }}</span>

            <input
              v-if="isInputRequired(element.type)"
              name="example"
              :type="element.type"
              v-model="element.value"
              :required="element.attributes.required"
              :disabled="!isUserHasAccess"
            />

            <textarea
              v-if="element.type === 'textarea' || element.type === 'html'"
              name="example"
              v-model="element.value"
              required
              :disabled="!isUserHasAccess"
            />

            <!-- Input for number - v.model.number is required -->
            <input
              v-else-if="element.type === 'number' || element.type === 'range'"
              name="example"
              :type="element.type"
              v-model.number="element.value"
              :step="element.attributes.step"
              :max="element.attributes.max"
              :min="element.attributes.min"
              :required="element.attributes.required"
              :disabled="!isUserHasAccess"
            />
            <NumberComponent
              v-else-if="element.type === 'formatted_number'"
              :editableComponent="true"
              :maxValue="Number(element.attributes.max) || Infinity"
              :minValue="Number(element.attributes.min) || -Infinity"
              :maximumDecimalValues="Number(element.attributes.step || 3)"
              :passedNumberValue="element.value"
              :disabledInput="!isUserHasAccess"
              @onNumberInputChange="onNumberComponentInputChange"
              :requiredInput="element.attributes.required"
              @toggleValidationError="toggleErrorInForm"
            />

            <!-- This input allows the user to set default value for hidden input -->
            <input
              v-if="element.type === 'hidden'"
              name="example"
              v-model="element.value"
              required
              :disabled="!isUserHasAccess"
            />
            <br />
            <a
              style="font-size: 13px; font-weight: 600"
              v-if="!element.layoutItem"
              @click="isMoreSettingsVisible = !isMoreSettingsVisible"
              >Zusätzliche Einstellungen<i
                style="margin-left: 5px"
                class="fa fa-angle-double-down"
              ></i
            ></a>
            <br />
            <br />
            <div class="more-settings" v-show="isMoreSettingsVisible">
              <label
                v-if="isPlaceholderRequired(element.type)"
                for="placeholder"
                >Platzhalter:</label
              >
              <input
                v-if="isPlaceholderRequired(element.type)"
                name="placeholder"
                type="text"
                v-model="element.placeholder"
              />

              <!-- Options for numbers / range -->
              <div v-if="isNumberRangeVisible(element.type)">
                <label for="label">Minimum</label>
                <input
                  name="label"
                  type="number"
                  v-model="element.attributes.min"
                  :disabled="!isUserHasAccess"
                />
                <label for="label">Maximum</label>
                <input
                  name="label"
                  type="number"
                  v-model="element.attributes.max"
                  :disabled="!isUserHasAccess"
                />
              </div>

              <!-- This input allows the user to set tabindex for non-layoutItem's -->
              <label v-if="!element.layoutItem" for="tabindex">Tabindex:</label>
              <input
                v-if="!element.layoutItem"
                name="tabindex"
                type="number"
                placeholder="Dieser Wert ist optional"
                v-model="element.attributes.tabindex"
                :disabled="!isUserHasAccess"
              />
              <!-- This input allows the user to set pattern for only type text -->
              <label v-if="element.type === 'text'" for="pattern"
                >Pattern:</label
              >
              <input
                v-if="element.type === 'text'"
                name="pattern"
                type="text"
                placeholder="Eingabemuster hinzufügen"
                v-model="element.attributes.pattern"
                :disabled="!isUserHasAccess"
              />

              <!-- This input allows the user to set the number of decimals for number inputs -->
              <label v-if="isNumberRangeVisible(element.type)"
                >Dezimalstellen:</label
              >
              <p
                class="decimal-description"
                v-if="isNumberRangeVisible(element.type)"
              >
                Erhöhungsschritte oder gewünschte Anzahl an Dezimalen
                definieren. Für Standardeinstellungen Feld leer lassen.
              </p>
              <input
                v-if="isNumberRangeVisible(element.type)"
                name="example decimals"
                type="number"
                min="1"
                step="any"
                v-model="element.attributes.step"
                :disabled="!isUserHasAccess"
              />

              <label v-show="isExampleFieldLabel(element.type)">Text:</label>
              <textarea
                v-if="isExampleFieldTextarea(element.type)"
                name="example"
                v-model="element.value"
                required
                :disabled="!isUserHasAccess"
              />
            </div>

            <!-- Dropdown preview - this is just for type: select -->
            <div v-if="element.type === 'select'">
              <h3>Dropdown vorschau</h3>
              <p>Wert: {{ dropdownSelection }}</p>
              <select
                :name="element.name"
                :id="element.name"
                v-model="dropdownSelection"
                :disabled="!isUserHasAccess"
              >
                <option
                  v-for="option in element.options"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.label }}
                </option>
              </select>
            </div>

            <div v-if="elementNeedsSettings">
              <div class="switch-group">
                <label class="caption">Feld Erforderlich</label>
                <label name="required" class="switch class pull-right">
                  <input
                    type="checkbox"
                    :checked="element.attributes.required"
                    @click="
                      element.attributes.required = !element.attributes.required
                    "
                    :disabled="!isUserHasAccess"
                  />
                  <span
                    class="slider round"
                    :disabled="!isUserHasAccess"
                  ></span>
                </label>
              </div>
              <div
                v-if="
                  element.type != 'file' &&
                  element.type != 'filenew' &&
                  isCreateCustomDB
                "
                class="switch-group"
              >
                <label class="caption">Feld hevorheben </label>
                <label name="highlight" class="switch class pull-right">
                  <input
                    type="checkbox"
                    :checked="element.highlight"
                    @click="element.highlight = !element.highlight"
                    :disabled="!isUserHasAccess"
                  />
                  <span
                    class="slider round"
                    :disabled="!isUserHasAccess"
                  ></span>
                </label>
              </div>
              <div v-if="elementNeedsDefaultValue" class="switch-group">
                <label class="caption">
                  Beispielwert als Standartwert verwenden
                </label>
                <label name="default" class="switch class pull-right">
                  <input
                    type="checkbox"
                    :checked="element.default || element.type === 'radio'"
                    @click="element.default = !element.default"
                    :disabled="!isUserHasAccess"
                  />
                  <span
                    class="slider round"
                    :disabled="!isUserHasAccess"
                  ></span>
                </label>
              </div>
              <div class="switch-group">
                <label class="caption">Feld sperren</label>
                <label name="required" class="switch class pull-right">
                  <input
                    type="checkbox"
                    :checked="element.attributes.disabled"
                    @click="
                      element.attributes.disabled = !element.attributes.disabled
                    "
                    :disabled="!isUserHasAccess"
                  />
                  <span
                    class="slider round"
                    :disabled="!isUserHasAccess"
                  ></span>
                </label>
              </div>

              <div
                class="switch-group"
                v-if="isChoiceWithAppearanceCard(element)"
              >
                <label class="caption">Bild im Hintergrund</label>
                <label name="required" class="switch class pull-right">
                  <input
                    type="checkbox"
                    :checked="isBackgroundImage"
                    @click="toggleImageBackGroundView()"
                    :disabled="!isUserHasAccess"
                  />
                  <span
                    class="slider round"
                    :disabled="!isUserHasAccess"
                  ></span>
                </label>
              </div>
              <div
                class="switch-group"
                v-if="isChoiceWithAppearanceCard(element)"
              >
                <label class="caption">Beschreibung hinzufügen</label>
                <label name="required" class="switch class pull-right">
                  <input
                    type="checkbox"
                    :checked="isShowDescription"
                    @click="toggleTitleDescriptionView()"
                    :disabled="!isUserHasAccess"
                  />
                  <span
                    class="slider round"
                    :disabled="!isUserHasAccess"
                  ></span>
                </label>
              </div>
            </div>
            <div
              v-if="element.type === 'smartmessage'"
              class="btn"
              @click="$emit('writeMessage', element)"
            >
              <span>Schreiben</span>
            </div>
            <input
              v-show="false"
              type="submit"
              value="Submit"
              ref="submitBtn"
            />
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormBuilder from '../widgets/FormBuilderV2.vue';
import cards from '../widgets/cards.vue';
import FilePicker from '../core/FilePicker.vue';
import IconPicker from '../widgets/IconPicker.vue';
import GeneralDropdown from '../core/general-dropdown.vue';
import { mapGetters } from 'vuex';
import { getTableItems } from '../../services/userTable';
import NumberComponent from '../widgets/NumberComponent.vue';

export default {
  name: 'elementProps',
  data() {
    return {
      invalidOptionName: false,
      checked: null,
      shakeName: false,
      dropdownSelection: null,
      isValidatingProcess: false,
      nextElement: null,
      isMoreSettingsVisible: false,
      isErrorInForm: false,
      buildURLId: undefined,
      databaseItemsList: [],
      isDbItemListLoading: false,
      iconPickerURLId: undefined,
    };
  },
  props: {
    element: Object,
    existingNames: Array,
    reservedElementKeys: Array,
    isCreateCustomDB: Boolean,
    isUserHasAccess: { type: Boolean, default: true },
    selectedDatabase: {
      type: Object,
      default: () => null,
    },
  },
  methods: {
    onDatabaseItemChange(dbItem) {
      this.element.value = dbItem.id;
    },
    async selectDatabaseLink(db, shouldClearValue) {
      this.isDbItemListLoading = true;
      if (shouldClearValue) {
        this.element.value = null;
      }
      this.element.selectedDatabaseCaption = db.caption;
      this.element.selectedDatabaseID = db.name;
      this.element.selectedDatabaseType = db.type;

      try {
        const listItems = await getTableItems(db.name);

        if (listItems && listItems.status === 200 && listItems.data) {
          if (db.type === 'loadprofile') {
            const filteredData = [...listItems.data].filter(
              (el) => el.id.includes('sheet') && el.ts_type === 'loadcurve'
            );
            this.databaseItemsList = filteredData;
          } else {
            this.databaseItemsList = listItems.data;
          }
          this.isDbItemListLoading = false;
        }
      } catch (error) {
        // eslint-disable-next-line
        console.log({ error });
        this.isDbItemListLoading = false;
        this.element.selectedDatabaseCaption = null;
        this.element.selectedDatabaseID = null;
        this.element.selectedDatabaseType = null;
      }
    },
    toggleCloseModal() {
      this.$emit('close');
    },
    handleSubmission() {
      if (!this.nameAlreadyExists) {
        if (this.isErrorInForm) return false;
        else if (this.isValidatingProcess) {
          this.$emit('changeElement', this.nextElement);
        } else {
          this.toggleCloseModal();
        }
      }
    },
    close() {
      this.isValidatingProcess = false;
      this.handleChoicesValues();
      this.$refs.submitBtn.click();
    },
    formSubmit(element) {
      this.isValidatingProcess = true;
      this.nextElement = element;
      this.$refs.submitBtn.click();
    },
    handleChoicesValues() {
      let el = this.element;
      if (el.type === 'radio') {
        let checked = el.options.find((e) => e.checked);
        el.value = checked != undefined ? checked.label : '';
      } else if (el.type === 'checkbox') {
        el.value = el.options.filter((e) => e.checked).map((e) => e.label);
      }
    },
    addOption() {
      var newOption = this.$refs.newOption.value;
      if (!this.optionNameExists(newOption)) {
        if (newOption != '') {
          let isChecked = this.element.options.length == 0;
          let option = { label: newOption, checked: isChecked };

          // Handle img-tag for card options
          if (this.isCardItem) option.img = '';

          // Add default value if none
          let hasCheckedOption = this.element.options.find(
            (e) => (e.checked = true)
          );
          if (!hasCheckedOption && this.element.options.length > 0) {
            this.element.options.forEach((e) => (e.checked = false));
            this.element.options[0].checked = true;
            this.element.value = this.element.options[0].label;
          }

          this.element.options.push(option);
          this.$refs.newOption.value = '';
          this.invalidOptionName = false;
        }
      } else {
        this.invalidOptionName = true;
      }
    },
    optionNameExists(optionName) {
      return (
        this.element.options.filter((o) => o.label === optionName).length > 0
      );
    },
    changeChecked: function (o, type) {
      if (type === 'radio') {
        this.element.options.forEach((e) => {
          e.checked = false;
        });
        o.checked = true;
        this.element.value = o.label;
      } else if (type === 'checkbox') {
        o.checked = !o.checked;
        if (o.checked) this.element.value.push(o.label);
        else
          this.element.value = this.element.value.filter((e) => e != o.label);
      }
    },
    getFiles(event) {
      this.element.files = event.target.files;
    },
    isInputRequired(type) {
      const typesWithInput = [
        'text',
        'email',
        'location',
        'date',
        'datetime-local',
        'hidden',
        'model',
      ];
      return typesWithInput.includes(type);
    },
    isPlaceholderRequired: function (type) {
      const typesWithPlaceholder = [
        'text',
        'email',
        'number',
        'textarea',
        'smartmessage',
        'formatted_number',
      ];
      return typesWithPlaceholder.includes(type);
    },

    // This function is important if the user uses CopyPaste
    transformName() {
      this.element.name = this.element.name.toLowerCase();
    },
    removeElement(option) {
      if (!this.isUserHasAccess) return;
      this.element.options = this.element.options.filter((el) => {
        return el != option;
      });
    },
    getLabelCaption(type) {
      let captions = {
        file: 'Datei',
        filenew: 'Datei New',
        email: 'E-Mail Adresse',
        number: 'Zahl',
        formatted_number: 'Zahl',
        model: 'Model',
        range: 'Zahl',
      };

      const sameCaptionForTheSomeTypes = [
        'textarea',
        'text',
        'hidden',
        'html',
        'date',
        'datetime-local',
      ];

      if (captions[type] != undefined) return captions[type];
      if (sameCaptionForTheSomeTypes.includes(type)) return 'Beispiel';
      return false;
    },
    saveListSchema(schema) {
      this.element.schema = schema;
    },
    isExampleFieldLabel(type) {
      return ['textarea', 'smartmessage'].includes(type);
    },
    isExampleFieldTextarea(type) {
      return ['textarea', 'html', 'smartmessage'].includes(type);
    },
    onFileSelected(file) {
      this.$emit('onFileSelected', file);
    },
    onFileDelete() {
      this.$emit('onFileDelete', this.element);
    },
    updateLinkType(type, i) {
      if (i || i == 0) this.$set(this.element.options[i], 'linkType', type);
      else this.$set(this.element, 'linkType', type);
    },

    toggleIconPickerURL(id) {
      if ((!id && id != 0) || this.iconPickerURLId == id)
        this.iconPickerURLId = undefined;
      else this.iconPickerURLId = id;
    },
    updateUrl(icon, i) {
      if (i || i == 0) this.$set(this.element.options[i], 'img', icon);
      else this.$set(this.element, 'url', icon);
    },
    onSheetFileSelect(event) {
      this.$emit('onSheetFileSelect', event.target.files[0]);
    },
    toggleTitleDescriptionView() {
      this.element.attributes.isShowTitleAndDescription =
        !this.isShowDescription;
      if (this.isShowDescription === false) {
        this.element.options.forEach((option) => {
          option.description = '';
        });
      }
    },
    toggleImageBackGroundView() {
      this.element.attributes.isImgShowInBackGround = !this.isBackgroundImage;
    },
    isChoiceWithAppearanceCard(element) {
      return (
        (element.type === 'radio' || element.type === 'checkbox') &&
        element.attributes.appearance === 'card'
      );
    },
    onNumberComponentInputChange(newValue) {
      this.element.value = newValue;
    },
    toggleErrorInForm(newValue) {
      this.isErrorInForm = newValue;
    },
    isNumberRangeVisible(type) {
      return ['range', 'number', 'formatted_number'].includes(type);
    },
  },

  computed: {
    ...mapGetters({
      getDatabaseList: 'getDatabaseList',
    }),
    addAnotherOption() {
      if (this.element.type === 'image') {
        return false;
      } else if (this.element.type === 'video') {
        return false;
      } else {
        return true;
      }
    },
    user() {
      return this.$store.state.user;
    },
    elementNeedsOptions() {
      if (typeof this.element != 'undefined')
        return (
          this.element.type === 'radio' ||
          this.element.type === 'checkbox' ||
          this.element.type === 'select' ||
          this.element.type === 'image' ||
          this.element.type === 'video'
        );
      else return false;
    },
    elementNeedsSettings() {
      let withoutSettings = [
        'title',
        'description',
        'horizontalrule',
        'togglelist',
        'wrapper',
        'linktodb',
      ];
      if (withoutSettings.includes(this.element.type)) return false;
      return true;
    },
    elementNeedsDefaultValue() {
      let withoutDefaultValue = ['file', 'radio', 'checkbox', 'filenew'];
      if (withoutDefaultValue.includes(this.element.type)) return false;
      return true;
    },
    nameAlreadyExists() {
      return (
        this.existingElementKeys.filter((e) => e === this.element.name).length >
        1
      );
    },
    existingElementKeys() {
      return this.existingNames.concat(this.reservedElementKeys);
    },
    isCardItem() {
      return (
        this.element.attributes.hasOwnProperty('appearance') &&
        this.element.attributes.appearance === 'card'
      );
    },
    baseStructure() {
      return {
        tabs: [
          {
            id: 0,
            rows: [
              {
                id: 0,
                cols: [
                  {
                    id: 0,
                  },
                ],
              },
            ],
          },
        ],
      };
    },
    isSheetDatabaseType() {
      return this.selectedDatabase && this.selectedDatabase.name === 'sheet';
    },
    isBackgroundImage() {
      return this.element.attributes.isImgShowInBackGround;
    },
    isShowDescription() {
      return this.element.attributes.isShowTitleAndDescription;
    },
  },
  components: {
    FormBuilder,
    Cards: cards,
    FilePicker,
    IconPicker,
    GeneralDropdown,
    NumberComponent,
  },
  directives: {
    clickOutside: {
      bind(el, binding, vnode) {
        el.eventOnClick = function (event) {
          // Check that the click was outside the el and its children
          if (!(el == event.target || el.contains(event.target))) {
            // call method provided in attribute value
            vnode.context[binding.expression]();
          }
        };

        document.addEventListener('click', el.eventOnClick);
      },
      unbind(el) {
        document.removeEventListener('click', el.eventOnClick);
      },
    },
  },
  mounted() {
    if (
      this.element.selectedDatabaseCaption &&
      this.element.selectedDatabaseID &&
      this.element.selectedDatabaseCaption !== null &&
      this.element.selectedDatabaseID !== null
    ) {
      const db = this.getDatabaseList.find(
        (el) =>
          el.name.trim() === this.element.selectedDatabaseID.trim() &&
          el.caption.trim() === this.element.selectedDatabaseCaption.trim()
      );

      if (db && Object.keys(db).length) {
        this.selectDatabaseLink(db, false);
      }
    }
  },
};
</script>

<style scoped>
@import 'https://use.fontawesome.com/releases/v5.6.3/css/all.css';

.modal {
  background: #ffffff;
  border-radius: 4px;
  display: block;
  width: 65%;
  text-align: left;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  line-height: 17px;
  color: #5f697a;
  top: 1.1%;
  height: 98%;
  right: 5%;
  float: right;
  left: auto;
  width: 425px;
  border-left: 1px solid #dee3e9;
  border-left-width: 1px;
  border-left-style: solid;
  border-left-color: rgb(222, 227, 233);
  flex: 1;
  float: right;
  position: fixed;
  border-radius: 0px 10px 10px 0px;
}

.modal.shift-right {
  right: 15%;
  top: 1%;
  height: 98%;
}

.content {
  background-color: #fff;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
}

.heading {
  padding: 15px 15px 0px;
  text-align: center;
}

.pull-right {
  float: right;
  margin-right: 15px;
  margin-top: 15px;
}

.tab {
  text-align: left;
  border-top: 1px solid #eaecf1;
  background: #fff;
  padding: 38px 40px 2px 40px;
  min-height: 190px;
}
.tab .icon-picker-url-selector {
  position: relative;
}

.already-exists {
  background: #ff050578;
}

.error {
  animation: shake 0.2s ease-in-out 0s 2;
  box-shadow: 0 0 0.5em red;
}

.options {
  width: 100%;
  margin: 0;
  height: 36px;
  display: inline;
}

.options .img-preview {
  width: 55px;
}
.options img {
  width: 50px;
}

.options table {
  width: 90%;
}

.options input {
  border: 0;
  background: transparent;
}

.options i {
  float: right;
  margin-top: -30px;
}

.options.large i {
  margin-top: -55px;
}

input[type='file'] {
  padding: 6px;
}

.options input[type='text'] {
  width: 68%;
  margin-left: 1px;
  display: inline;
  margin-top: 0px;
  margin-bottom: 0px;
  padding-top: 0px;
  height: 43px;
  font-size: 15px;
}

.options input[type='radio'],
.options input[type='checkbox'] {
  width: 21px;
  float: left;
  margin-bottom: 9px;
  height: 19px;
  margin-top: 13px;
}

.type-select-wrapper {
  display: flex;
  justify-content: space-around;
  font-size: 15px;
  color: #464d5d;
  font-weight: 400;
  line-height: 35px;
  margin-bottom: 5px;
}
.type-select-wrapper span {
  cursor: pointer;
}
.type-select-wrapper span.active {
  text-decoration: underline;
}

.icon-wrapper {
  display: flex;
  flex-wrap: wrap;
  height: 160px;
  overflow: auto;
}
.icon-wrapper img {
  cursor: pointer;
  width: 26px;
  padding: 6px;
  margin: 5px;
  background: #cfd0d3;
}

.image-preview {
  width: 50px;
}

h1 {
  padding-top: 50px;
  padding-bottom: 8px;
  text-align: center;
  font-size: 33px;
  color: #464d5d;
  margin: 0 0 12px;
  font-weight: 400;
  line-height: 35px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
}

h3 {
  color: rgba(85, 93, 109, 0.4);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 10px;
}

h4 {
  color: rgba(85, 93, 109, 0.4);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 0px;
}

select {
  width: 70%;
}

.date {
  width: 53%;
}

.time {
  width: 33%;
}

textarea {
  resize: none;
  float: left;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  padding-bottom: 15px;
  margin-bottom: 0;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 200px;
  width: 100%;
  overflow: scroll;
}

button {
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
  margin-top: 25px;
  margin-bottom: 20px;
  margin-right: 30px;
  width: fit-content;
}

button.default {
  color: #464d5d;
  background: #fff;
}

.input-group {
  display: inline-block;
  width: 100%;
}

.imput-group > input {
  width: 40%;
  margin: 0px 20px 20px 0px;
}

.btn-green {
  color: white;
  background: #4aae9b;
  border: 1px solid #4aae9b;
  border-radius: 2px;
}

.btn {
  text-decoration: none;
  color: #fff;
  border: 3px solid #000;
  border-radius: 0.375em;
  cursor: unset;
  display: inline-block;
  font-family: proxima-nova, Helvetica Neue, Arial, sans-serif;
  font-weight: 700;
  line-height: 23px;
  padding: 0.5rem 1.5rem;
  white-space: pre;
  font-size: 0.9375rem;
  opacity: 1;
  transition: transform 0.2s linear 0s, background-color 0.2s linear 0s;
  transform: translateY(0) scale(1.001);
  background-color: #000;
  margin-bottom: 10px;
}
ul.tabsLabels {
  display: inline-block;
  padding: 0;
  margin: 0 0 -1px;
}

.modal ul.tabsLabels li {
  display: inline-block;
  margin-right: 44px;
  list-style: none;
  padding: 0;
  line-height: 14px;
}

.modal:not(.custom) li {
  font-size: 14px;
  line-height: 25px;
  color: #7e8890;
}

.modal ul.tabsLabels a {
  color: #a4abb1;
  font-size: 12px;
  font-weight: 400;
  text-transform: uppercase;
  padding: 21px 7px 22px 33px;
  border-bottom: 2px solid transparent;
  display: block;
  position: relative;
}

.modal ul.tabsLabels a.datetime {
  padding: 21px 7px 22px 0px;
}

a {
  text-decoration: none;
  -webkit-transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  -o-transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  cursor: pointer;
}

a {
  background-color: transparent;
}

.modal ul.tabsLabels a.active {
  border-color: #52b266;
}

.modal ul.tabsLabels a.active,
.modal ul.tabsLabels a:hover {
  color: #464d5d;
  text-decoration: none;
}

/*@media not all, not all, (-webkit-min-device-pixel-ratio: 1.5), not all, (min-resolution: 1.5dppx)*/
.tabsLabels .email {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -1100px -1110px;
}

.tabsLabels .alert {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -546px -1110px;
}

p {
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
  color: #7e8890;
  margin: 25px 0px 25px 0px;
}

.systems {
  background-color: #f9f9fb;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  color: #5f697a;
  line-height: 17px;
  margin: 0;
  display: block;
  overflow: auto;
  width: 100%;
}

.item-wrapper {
  display: block;
  position: relative;
  float: left;
  width: 120px;
  border-radius: 4px;
  background: #fff;
  height: 150px;
  text-align: center;
  margin: 0 39px 43px 0;
  -webkit-box-shadow: 0 1px 2px rgba(43, 59, 93, 0.29);
  box-shadow: 0 1px 2px rgba(43, 59, 93, 0.29);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.item-wrapper h2 {
  color: #424956;
  font-size: 12px;
  font-weight: 400;
  line-height: inherit;
  margin-top: 0px;
}

.systems-wrapper {
  width: 100%;
  margin: 24px 31px;
}

.img-wrapper {
  width: 100%;
  height: 111px;
}

.systems .logo {
  position: absolute;
  width: 70%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.input-group > button {
  min-width: 0;
  width: 99px;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
  background: #fff;
  margin-bottom: 0;
  margin-left: 0;
  border-radius: 0 3px 3px 0;
  margin-top: 0;
  font-size: 35px;
  font-weight: 200;
}

.input-group > select {
  margin-right: 0;
  border-radius: 0 3px 3px 0;
}

form {
  background: #f9f9fb;
  width: 100%;
  padding: 30px;
  text-align: left;
}

label {
  font-family: 'Open Sans', open-sans, sans-serif;
  display: block;
  padding-top: 0;
  padding-bottom: 9px;
  margin-right: 10px;
  margin-bottom: 0px;
  color: #464d5d;
  font-size: 13px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-weight: 300;
  width: 50%;
}

input,
select {
  border-radius: 0;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  width: 100%;
  margin-bottom: 0;
  height: 37px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0px 15px 0px 15px;
}
input[type='range'] {
  padding: 0;
}

.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: '';
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #000;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/*Switch*/
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: '';
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #000;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.option-list {
  clear: both;
  float: left;
  position: relative;
  width: 100%;
}

.option-list > ul {
  padding: 0;
  margin: 0;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  list-style: none;
}

.option-list ul li {
  float: left;
  clear: both;
  width: 100%;
  border-bottom: 1px solid #d8dee6;
  padding: 15px 0;
  font-size: 14px;
  color: #7e8890;
  line-height: 35px;
}

.option-list ul li.active {
  color: #323a45;
}

.switch-group {
  height: 65px;
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.switch-group > label.caption {
  height: 53px;
  padding-top: 19px;
}

.new-item {
  border: 0;
  background: transparent;
  font-size: 15px;
}

.new-item::placeholder {
  text-decoration: underline;
}

.new-item:focus::placeholder {
  color: transparent;
}

.new-item:focus {
  background: #fff;
}

#add-element {
  background: #fff;
  padding: 0;
}

.decimal-description {
  margin: 0 0 5px 0;
}

@keyframes shake {
  0% {
    margin-left: 0rem;
  }
  25% {
    margin-left: 0.5rem;
  }
  75% {
    margin-left: -0.5rem;
  }
  100% {
    margin-left: 0rem;
  }
}

input.invalid {
  background-color: #ff050578;
  color: red;
  border: 1px solid;
}

p.invalid {
  color: red;
}

.list-wrapper {
  margin-bottom: 25px;
}

.list-wrapper .schema-item {
  border: solid 1px #9e9e9e;
  width: 94%;
  color: #444444;
  padding: 10px;
}

.list-wrapper input.new-item {
  padding: 0;
  margin: 0;
}

.list-wrapper .item-list {
  margin-top: 15px;
}

.list-wrapper .add-button-wrapper {
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
}

.list-wrapper .add-button-wrapper .add-button {
  cursor: pointer;
  display: block;
  color: white;
  border-radius: 50%;
  background-color: #191f25;
  height: 35px;
  width: 35px;
  line-height: 37px;
  font-size: 25px;
  font-weight: 100;
  -webkit-box-shadow: 0.5px 0.87px 5px 0 rgb(0 0 0 / 28%);
  box-shadow: 0.5px 0.87px 5px 0 rgb(0 0 0 / 28%);
  -webkit-transition: -webkit-transform 0.2s ease-in-out;
  transition: -webkit-transform 0.2s ease-in-out;
  transition: transform 0.2s ease-in-out;
  transition: transform 0.2s ease-in-out, -webkit-transform 0.2s ease-in-out;
  background-size: 100%;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  margin-top: 15px;
}

.list-wrapper .add-button-wrapper .add-button:hover {
  transform: scale(1.1);
}

.list-wrapper .item-list .list-item {
  border-bottom: solid 1px;
  padding: 5px 0 5px 0;
}

.list-wrapper .item-list .list-item input {
  margin: 0;
}

/* el-props-form-builder */

::v-deep .el-props-form-builder #form {
  width: 100%;
}

::v-deep .el-props-form-builder .form-header {
  display: none;
}

::v-deep .el-props-form-builder .add-button {
  height: 25px;
  width: 25px;
  line-height: 27px;
  font-size: 25px;
}

::v-deep .el-props-form-builder .drop-down {
  top: 0;
  margin-left: 0;
  margin-top: 15px;
  height: fit-content;
}

[disabled] {
  opacity: 0.5;
  cursor: not-allowed !important;
}
.edit-item ::v-deep .file-selected {
  margin-left: 0 !important;
  width: 100%;
}

.modal .link-db-container .database-dropdown ::v-deep .customDropdown {
  width: 100% !important;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  height: 37px;
  color: #464d5d;
  justify-content: space-between;
  padding: 0px 15px 0px 15px;
}

.modal
  .link-db-container
  .database-dropdown
  ::v-deep
  .database-dropdown-value-container {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-all;
  text-align: left;
}

.modal .link-db-container ::v-deep .database-dropdown {
  width: 100%;
}
.modal .link-db-container ::v-deep .database-dropdown .dropdown-menu {
  width: 100%;
}

.modal
  .link-db-container
  ::v-deep
  .database-dropdown
  .dropdown-menu
  .dropdown-item {
  width: 94%;
}

.modal .content .tab .loading-overlay {
  position: absolute;
  background: transparent;
  width: 100%;
  z-index: 1;
  top: 0;
  text-align: center;
  height: 100%;
  border-radius: 4px;
}
.modal .content .tab .loading-overlay .progress-icon {
  content: ' ';
  display: block;
  width: 25px;
  height: 25px;
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #1f2532c7;
  border-color: #1f2532c7 transparent #1f2532c7 transparent;
  animation: progress-icon 1.2s linear infinite;
  margin: 0 auto;
  top: 5px;
  position: absolute;
  left: 44%;
}

@keyframes progress-icon {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.options .title-input {
  border: 2px solid #000;
  border-radius: 4px;
  margin-left: 0px !important;
}

.options .description-input {
  margin-top: 5px;
  border: 1px solid #747070;
  height: 100px;
}
::v-deep .number-component .number-input {
  border: 1px solid #dee3e9 !important;
  border-radius: 2px;
  border-radius: 0;
  background: #fff;
  height: 37px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  box-shadow: none;
  box-sizing: border-box;
  padding: 0px 15px 0px 15px;
}
.tab .icon-picker-url-selector .btn {
  margin-bottom: 0;
  margin-top: 5px;
}
</style>
